module.exports = __webpack_public_path__ + "static/media/iconfinder_diamond_430094.84d18de4.svg";